import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MainService } from 'src/app/services/main/main.service';
import { mobile_mask } from 'src/app/shared/regex';
import { SimpleDialogComponent } from 'src/app/shared/simple-dialog/simple-dialog.component';
import { getUserProfile, getUserProfiles, setUserProfiles } from 'src/app/core/session';

@Component({
  selector: 'app-alternate-contact',
  templateUrl: './alternate-contact.component.html',
  styleUrls: ['./alternate-contact.component.scss']
})
export class AlternateContactComponent implements OnInit {

  alternateContact: UntypedFormGroup;

  public mask = mobile_mask;
  access_token = localStorage.getItem('token');
  profile: any;

  constructor(
    private fb: UntypedFormBuilder,
    private mainService: MainService,
    public dialog: MatDialog
  ) {
    this.alternateContact = this.fb.group({
      alternate_name: ['', [Validators.required]],
      alternate_phone: ['', [Validators.required, Validators.maxLength(10), Validators.minLength(10)]],
      alternate_email: ['', [Validators.required, Validators.email]],
      alternate_role: ['', [Validators.required]]
    });
  }

  ngOnInit() {
    // Initialization code here
    this.getAlternateContact();
  }

  submitAlternateContact() {
    if (this.alternateContact.invalid) {
      this.alternateContact.markAllAsTouched();
      this.alternateContact.controls.alternate_phone.markAsDirty();
      return;
    }

    const { alternate_name, alternate_phone, alternate_email, alternate_role } = this.alternateContact.value;

    this.mainService.api(
      { access_token: this.access_token, alter_name: alternate_name, alter_phone: alternate_phone, alter_email: alternate_email, alter_role: alternate_role },
      'add_alternate_contact',
      false,
      'object'
    ).subscribe(response => {
      const isError = response.is_error === 1;
      this.mainService.customPopups(isError ? response.err || response.message : "Alternate contact details saved successfully", isError ? 1 : 0);

      if (!isError) {
        const emailChanged = this.checkChanged(this.profile.alternate_email, alternate_email);
        const phoneChanged = this.checkChanged(this.profile.alternate_phone, alternate_phone);

        const alternate_email_verified = this.profile.alternate_email && !this.profile.alternate_email_verified ? 0 : (emailChanged ? 0 : 1);
        const alternate_phone_verified = this.profile.alternate_phone && !this.profile.alternate_phone_verified ? 0 : (phoneChanged ? 0 : 1);

        const updatedProfile = { ...getUserProfile(), ...this.alternateContact.value, alternate_email_verified, alternate_phone_verified };

        setUserProfiles([updatedProfile]);
        this.profile = updatedProfile;
        this.alternateContact.markAsPristine();
      }
    });
  }


  getAlternateContact() {
    this.profile = localStorage.getItem("userProfileData") && getUserProfiles() && getUserProfile();

    if (this.profile) {
      this.alternateContact.patchValue({
        alternate_name: this.profile.alternate_name || '',
        alternate_phone: this.profile.alternate_phone ? this.profile.alternate_phone.slice(-10) : '',
        alternate_email: this.profile.alternate_email || '',
        alternate_role: this.profile.alternate_role || '',
      });
    }

  }


  openRemoveModal() {
    let confirmDialogRef = this.dialog.open(SimpleDialogComponent, {
      width: '480px',
      disableClose: true,
      panelClass: 'simpleDialog',
      data: {
        type: 807,
        title: '',
        send_data: {
        }
      }
    });
    confirmDialogRef.afterClosed().subscribe(result => {
      if (result == 1) {
        // this._location.back()
        this.deleteContact();
      }
      return;
    });
    return
  }

  deleteContact() {
    this.mainService.api({
      access_token: this.access_token,
    }, 'delete_alternate_contact', false, 'object').subscribe((response) => {
      if (response.is_error == 1) {
        this.mainService.customPopups(response.err || response.message, 1)
      } else {
        this.alternateContact.reset();

        this.profile.alternate_name = '';
        this.profile.alternate_phone = '';
        this.profile.alternate_email = '';
        this.profile.alternate_role = '';
        this.mainService.customPopups("Alternate contact details deleted successfully", 0);
        setUserProfiles([{ ...getUserProfile(), ...this.alternateContact.value }])
        this.alternateContact.markAsPristine();
      }
    })
  }

  checkChanged(original = '', curr = '') {
    if (!original) return true;
    if (original.includes('+1-')) original = original.slice(-10);
    if (curr == original) return false;
    return true;
  }
}
